import UserClient from "./userClient";
import axios from "axios";

export default class CorpClient extends UserClient {
  constructor() {
    super("corp");

    this.httpClient = axios.create({
      baseURL: `${process.env.VUE_APP_APIURL}/api/app/corp`,
      headers: { Authorization: `${this.access_token}` }
    });
  }

  async getDirectorList(params) {
    return this.httpClient.post("director-list", params).then(res => res.data);
  }

  async deleteCorpDirector(params) {
    return this.httpClient
      .post("corp-director-remove", params)
      .then(res => res.data);
  }
}
